import * as React from 'react';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
  Divider,
  Grid,
  CircularProgress,
  FormHelperText,
  Autocomplete
} from '@mui/material';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { authenticationService } from 'src/services';
import { multy_post, get } from 'src/services/httpClient.service';


const API_BASE_URL = process.env.REACT_APP_BASE_API_URL

const AddFranchisee = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const [loading, setLoading] = React.useState(false);
  const [companies, setCompanies] = React.useState([]);
  const [states, setStates] = React.useState([]);
  const [stateNameToIdMap, setStateNameToIdMap] = React.useState({});
  const [loadingCities, setLoadingCities] = React.useState(false);

  const [cities, setCities] = React.useState([]);
  const [selectedState, setSelectedState] = React.useState('');
  const [priceLists, setPriceLists] = React.useState([]);
  // const [selectedPriceListId, setSelectedPriceListId] = useState("");
  const [areaList, setAreaList] = React.useState([]);
  const [zonelist, setZoneList] = React.useState([])
  const [selectedAreaId, setSelectedAreaId] = React.useState('');
  const [logoPreview, setLogoPreview] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const [operatorsList, setOperatorList] = React.useState<any[]>([]);
  const [billingTaxTypes, setBillingTaxTypes] = React.useState([]);

  const billingtaxtype = async () => {
    try {
      const res = await get(
        `${API_BASE_URL}/api/billing-tax-type/vendor/${vendorId}/getAll`
      );
  
      console.log("billingtype", res);
  
      if (res?.success && res?.data) {
        setBillingTaxTypes(res.data);
      }
    } catch (error) {
      console.error("Error fetching billing tax types", error);
    }
  };

  React.useEffect(() => {
    billingtaxtype();
  }, []);

  //company
  React.useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await get(`${API_BASE_URL}/api/company/vendor/${vendorId}/fetchAll`);
        if (response && Array.isArray(response)) {
          setCompanies(response);
        } else {
          console.error("Unexpected API response:", response);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
        showSnackbar("Failed to load company list", "error");
      }
    };

    fetchCompanies();
  }, []);

  //state
  const fetchStates = async () => {
    try {

      const response = await get(`${API_BASE_URL}/states`);
      if (Array.isArray(response)) {
        setStates(response);


        // Create a mapping of state names to their index (as temporary ID)
        const mapping = {};
        response.forEach((stateName, index) => {
          mapping[stateName] = index + 1; // Using index+1 as temporary ID
        });
        setStateNameToIdMap(mapping);
      }
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  React.useEffect(() => {
    fetchStates();
  }, []);

  //cities
  const fetchCities = async (stateName) => {
    if (!stateName) {
      setCities([]);
      return;
    }

    setLoadingCities(true); // ✅ show loading before starting the API call

    try {
      const response = await get(`${API_BASE_URL}/cities?stateName=${encodeURIComponent(stateName)}`);
      console.log("City API Response:", response);

      // ✅ handle multiple response formats safely
      if (Array.isArray(response)) {
        setCities(response);
      } else if (Array.isArray(response.data)) {
        setCities(response.data);
      } else if (Array.isArray(response.cities)) {
        setCities(response.cities);
      } else if (response.data && Array.isArray(response.data.data)) {
        setCities(response.data.data);
      } else {
        console.warn("Unexpected city API format:", response);
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCities([]);
    } finally {
      setLoadingCities(false); // ✅ always stop loading (success or error)
    }
  };

  const handleImageChange = (e) => {
  const file = e.target.files[0];

  if (file) {
    setFormData((prev) => ({
      ...prev,
      companyLogo: file
    }));

    setLogoPreview(URL.createObjectURL(file));
  }
};




  const [formData, setFormData] = React.useState({
    // Basic Information
    name: '',
    company: '',
    companyId: '',
    billingTaxId:'',
    parent: '',
    franchiseeCode: '',
    status: true,
    openingAmount: '',
    openingType: 'Debit',
    franchiseeType: '',
    description: '',
    billNotes: '',
    slogan: '',

    // Address Information
    addressLine1: '',
    addressLine2: '',
    //addressLine3: '',
    //country: 'India',
    //state: '',
    zone: '',
    //city: '',
    // area: '',
    postCode: '',

    // Contact Information
    mobileNo: '',
    phoneNo: '',
    email: '',

    // Tax Information
    serviceTaxNo: '',
    entertainmentTaxNo: '',
    gstNo: '',
    panNo: '',
    aadharNo: '',

    // Financial Information
    creditLimit: '',
    onlineRechargeMinAmount: '',
    businessName: '',
  

  

    // Franchisee Settings
    priceListId: '',
    disablePostPaidCustomerCreation: false,
    isApplyFranchiseeInfoInBill: false,
    isManageUserWallet: false,
    isManageLCOWallet: false,
    disableSubTypeDay: false,
    disableSubTypeOption: false,

    // Logo
    companyLogo: null,
    logoPath: '',

    //venderid
    vendorId: vendorId,
    franchiseId: franchiseId,

    //Subscription Extended Date
    subscriptionExtendedDays:'',

    //locations
    areaId: '',
    areaName: ''
  });

  // const fetchPriceListByCity = async (areaId) => {
  //   try {
  //     const response = await get(
  //       `${API_BASE_URL}/api/area-wise-price-list/vendor/${vendorId}/searchByAreaId?areaId=${areaId}`
  //     );

  //     console.log("Price List API Response:", response);
  //     if (response?.data && Array.isArray(response.data)) {
  //       setPriceLists(response.data);
  //     } else {
  //       setPriceLists([]);
  //     }

  //   } catch (error) {
  //     console.error("Error fetching price list:", error);
  //     setPriceLists([]);
  //   }
  // };

  // React.useEffect(() => {
  //   if (formData.areaId != null && formData.areaId != undefined && formData.areaId != "") {
  //     fetchPriceListByCity(formData.areaId);
  //   }
  // }, [formData.areaId]);

  const fetchPriceListByVendor = async () => {
    try {
      const response = await get(
        `${API_BASE_URL}/api/area-wise-price-list/vendor/${vendorId}/getPriceListsByVendorId`
      );

      console.log("Price List API Response:", response);
      if (response?.data && Array.isArray(response.data)) {
        setPriceLists(response.data);
      } else {
        setPriceLists([]);
      }

    } catch (error) {
      console.error("Error fetching price list:", error);
      setPriceLists([]);
    }
  };
  React.useEffect(() => {
    fetchPriceListByVendor();
  }, []);


  const [errors, setErrors] = React.useState({
    name: "",
    companyId: "",
    status: "",
    openingAmount: "",
    openingType: "",
    addressLine1: "",
    addressLine2: "",
    phoneNo: "",
    email: "",
    priceListId: "",
    disablePostPaidCustomerCreation: "",
    isApplyFranchiseeInfoInBill: "",
    isManageUserWallet: "",
    disableSubTypeDay: "",
    disableSubTypeOption: "",
    areaId: ""
  });

  const validateForm = () => {
    let tempErrors = {
      name: "",
      companyId: "",
      
      status: "",
      openingAmount: "",
      openingType: "",
      addressLine1: "",
      addressLine2: "",
      phoneNo: "",
      email: "",
      priceListId: "",
      disablePostPaidCustomerCreation: "",
      isApplyFranchiseeInfoInBill: "",
      isManageUserWallet: "",
      disableSubTypeDay: "",
      disableSubTypeOption: "",
      areaId: '',

    };

    let isValid = true;

    // Add your validation logic here for each field
    // Example validations:

    // Basic Information validations
    if (!formData.name.trim()) {
      tempErrors.name = "Name is required";
      isValid = false;
    }
    console.log(formData)
    if (!formData.areaId) {
      tempErrors.areaId = "Address is required";
      isValid = false;
    }


    if (!formData.companyId) {
      tempErrors.companyId = "Company is required";
      isValid = false;
    }

    if (!formData.openingAmount.trim()) {
      tempErrors.openingAmount = "openingAmount is required";
      isValid = false;
    }

    // if (!formData.creditLimit.trim()) {
    //   tempErrors.creditLimit = "creditLimit is required";
    //   isValid = false;
    // }

    // if (!formData.onlineRechargeMinAmount.trim()) {
    //   tempErrors.onlineRechargeMinAmount = "onlineRechargeMinAmount is required";
    //   isValid = false;
    // }

   

    if (!formData.phoneNo.trim()) {
      tempErrors.phoneNo = "phone number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phoneNo)) {
      tempErrors.phoneNo = "phone number must be 10 digits";
      isValid = false;
    }

    if (!formData.priceListId.trim()) {
      tempErrors.priceListId = "priceListId is required";
      isValid = false;
    }



    if (!formData.email.trim()) {
      tempErrors.email = "email required";
      isValid = false;
    } else if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      tempErrors.email = "Please enter a valid email address";
      isValid = false;
    }

    // Address validations
    if (!formData.addressLine1.trim()) {
      tempErrors.addressLine1 = "Address is required";
      isValid = false;
    }

    if (!formData.addressLine2.trim()) {
      tempErrors.addressLine2 = "Landmark is required";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };


  const getOperatorList = async () => {
    try {
      setLoading(true);

      const response = await get(`${API_BASE_URL}/api/operators/vendor/${vendorId}/getOperatorAccountTypeList`, {params: {accountTypes: "OWNER,DISTRIBUTOR"}});
      const data = Array.isArray(response?.data) ? response.data : [];
      setOperatorList(data);
    } catch (error: any) {
      if (error?.response?.status === 404) {
        setOperatorList([]);
      } else {
        showSnackbar(error?.message || "Failed to fetch operators", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getOperatorList()
  }, [])


  const fetchAreas = async () => {
    try {
      const response = await get(
        `${API_BASE_URL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
      );
      if (response) setAreaList(response?.data);
      console.log('city', response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };

  React.useEffect(() => {
    fetchAreas();

  }, []);

  /* zoneslist api */

  const handlezonelist = async () => {

    try {

      const response = await get(`${API_BASE_URL}/api/miscellaneous/zone/vendor/${vendorId}/findAll`)
      console.log('zone', response?.data)
      setZoneList(response?.data)

    } catch (error) {
      console.log("zonelist", error)
    }

  }

  React.useEffect(() => {
    //handlezonelist();
  }, [])





  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value); 
    //  if (name === "areaName") {
    //     fetchPriceListByCity(value);
    //   }

    // Update selected price list
    if (name === "priceListId") {
      setFormData(prev => ({
        ...prev,
        priceListId: value
      }));
    }

    // Update form data
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error for this specific field when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  // const handleFileChange = (e) => {
  //   setFormData(prev => ({
  //     ...prev,
  //     logo: e.target.files[0]
  //   }
  // ));
  // };




  const preparePayload = () => {
    return {
      aadharNo: formData.aadharNo || '',
      addressLine1: formData.addressLine1 || '',
      addressLine2: formData.addressLine2 || '',
      billingTaxId: formData.billingTaxId || '',
      //addressLine3: formData.addressLine3 || '',
      //area: formData.area || '',
      billNotes: formData.billNotes || '',
      businessName: formData.businessName || '',
      //city: formData.city || '',
      company: formData.company || '',
      companyId: formData.companyId || '',
      //country: formData.country || '',
      creditLimit: parseFloat(formData.creditLimit) || 0,
      description: formData.description || '',
      disablePostPaidCustomerCreation: formData.disablePostPaidCustomerCreation,
      disableSubTypeDay: formData.disableSubTypeDay,
      disableSubTypeOption: formData.disableSubTypeOption,
      email: formData.email || '',
      entertainmentTaxNo: formData.entertainmentTaxNo || '',
      franchiseeCode: formData.franchiseeCode || '',
      priceListId: formData.priceListId || '',
      franchiseeType: formData.franchiseeType || '',
      gstNo: formData.gstNo || '',
      isApplyFranchiseeInfoInBill: formData.isApplyFranchiseeInfoInBill,
      isManageUserWallet: formData.isManageUserWallet,
      isManageLCOWallet: formData.isManageLCOWallet,
      // logoPath: formData.logoPath || '', // You might need to handle file upload separately
      mobileNo: formData.mobileNo || '',
      name: formData.name || '',
      onlineRechargeMinAmount: parseFloat(formData.onlineRechargeMinAmount) || 0,
      openingAmount: parseFloat(formData.openingAmount) || 0,
      openingType: formData.openingType || 'Debit',
      panNo: formData.panNo || '',
      parent: formData.parent || '',
      phoneNo: formData.phoneNo || '',
      postCode: formData.postCode || '',
      serviceTaxNo: formData.serviceTaxNo || '',
      slogan: formData.slogan || '',
      //state: formData.state || '',
      status: formData.status,
      zone: formData.zone || '',
      areaId: formData.areaId || '',
      //venderid
      vendorId: vendorId,
      franchiseId: franchiseId

    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;


    try {
      setLoading(true);
      const payload = preparePayload();
       const formDataObj = new FormData();


      
    // append normal fields
    Object.keys(payload).forEach(key => {
      formDataObj.append(key, payload[key]);
    });

    // append image separately
    if (formData.companyLogo) {
      formDataObj.append("companyLogo", formData.companyLogo);
    }

    // append subscription days
    formDataObj.append("subscriptionExtendedDays", formData.subscriptionExtendedDays);

      





      const response = await multy_post(`${API_BASE_URL}/api/franchisees`, formDataObj);
      console.log('Response:', response);
      if (response.id !== null) {
        showSnackbar('Franchisee created successfully!', 'success');
        navigate('/franchise');
      }
    } catch (error) {
      console.log('error:', error);
      const errorMessage = error?.response?.data?.message ||
        error.response?.error ||
        error?.message || 'something went wrong'

      showSnackbar(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" sx={{ padding: 2 }}>
      <Typography variant="h6" gutterBottom>Add Franchisee</Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth disabled={loading} >
            <InputLabel>Company</InputLabel>
            <Select
              name="companyId"
              value={formData.companyId}
              label="Company"
              error={!!errors.companyId}
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedCompany = companies.find((c) => c.id === selectedId);

                setFormData((prev) => ({
                  ...prev,
                  companyId: selectedId,
                  company: selectedCompany ? selectedCompany.companyName : '', // 👈 Store name too
                }));


              }}
            >
              <MenuItem value="">Select Company</MenuItem>
              {companies.map((company) => (
                <MenuItem key={company.id} value={company.id}>
                  {company.companyName}
                </MenuItem>
              ))}
              {errors.companyId && <FormHelperText error>{errors.companyId}</FormHelperText>}
            </Select>

          </FormControl>

        </Grid>


        <Grid item xs={12} sm={6} md={3}>
      <FormControl fullWidth disabled={loading}>
        <InputLabel>Parent</InputLabel>
        <Select
          name="parent"
          value={formData.parent}
          label="Parent"
          onChange={handleChange}
        >
          <MenuItem value="">Select Parent</MenuItem>
          {operatorsList.map((operator) => (
            <MenuItem key={operator.id} value={operator.id}>
              {operator.operatorName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

        {/* <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Parent"
            name="parent"
            value={formData.parent}
            onChange={handleChange}
            disabled={loading}
          />
        </Grid> */}

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Franchisee Code"
            name="franchiseeCode"
            value={formData.franchiseeCode}
            onChange={handleChange}
            disabled={loading}
            
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                name="status"
                checked={formData.status}
                onChange={handleSwitchChange}
                color="primary"
                disabled={loading}
              />
            }
            label="Status"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Opening Amount"
            name="openingAmount"
            type="number"
            value={formData.openingAmount}
            onChange={handleChange}
            disabled={loading}
            error={!!errors.openingAmount}
            helperText={errors.openingAmount}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth disabled={loading} error={!!errors.openingType}>
            <InputLabel>Opening Type</InputLabel>
            <Select
              name="openingType"
              value={formData.openingType}
              label="Opening Type"
              onChange={handleChange}
            >
              <MenuItem value="Debit">Debit</MenuItem>
              <MenuItem value="Credit">Credit</MenuItem>
            </Select>
            {errors.openingType && <FormHelperText error>{errors.openingType}</FormHelperText>}
          </FormControl>
        </Grid>

        {/* <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>Franchisee Type</InputLabel>
            <Select
              name="franchiseeType"
              value={formData.franchiseeType}
              label="Franchisee Type"
              onChange={handleChange}
            >
              <MenuItem value="">Search Franchisee Type</MenuItem>
              {
                operatorsList.map((distributer) => (
                  <MenuItem key={distributer.id} value={distributer.id}>
                    {distributer.email}
                  </MenuItem>
                ))
              }

            </Select>
          </FormControl>
        </Grid> */}

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Description"
            name="description"
            multiline
            rows={3}
            value={formData.description}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.description}
          // helperText={errors.description}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Franchisee Bill Notes"
            name="billNotes"
            multiline
            rows={3}
            value={formData.billNotes}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.billNotes}
          // helperText={errors.billNotes}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Slogan"
            name="slogan"
            value={formData.slogan}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.slogan}
          // helperText={errors.slogan}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>Address Information</Typography>



      <Grid container spacing={3}>



        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Address Line"
            name="addressLine1"
            value={formData.addressLine1}
            onChange={handleChange}
            disabled={loading}
            error={!!errors.addressLine1}
            helperText={errors.addressLine1}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Landmark/Village"
            name="addressLine2"
            value={formData.addressLine2}
            onChange={handleChange}
            disabled={loading}
            error={!!errors.addressLine2}
            helperText={errors.addressLine2}
          />
        </Grid>

        {/* <Grid item xs={12} sm={6} md={3}>
      <TextField
        fullWidth
        label="Address Line 3"
        name="addressLine3"
        value={formData.addressLine3}
        onChange={handleChange}
        disabled={loading}
        
      />
    </Grid> */}

        {/* <Grid item xs={12} sm={6} md={3}>
      <FormControl fullWidth disabled={loading} error={!!errors.country}>
        <InputLabel>Country</InputLabel>
        <Select
          name="country"
          value={formData.country}
          label="Country"
          onChange={handleChange}
        >
          <MenuItem value="">Select Country</MenuItem>
          <MenuItem value="India">India</MenuItem>
          
        </Select>
        {errors.country && <FormHelperText error>{errors.country}</FormHelperText>}
      </FormControl>
    </Grid> */}

        {/* <Grid item xs={12} sm={6} md={3}>
      <FormControl fullWidth disabled={loading} error={!!errors.state}>
  <InputLabel>State</InputLabel>
  <Select
    name="state"
    value={formData.state}
    label="State"
    onChange={(e) => {
      const selectedStateName = e.target.value;

      setSelectedState(selectedStateName);
      setFormData((prev) => ({
        ...prev,
        state: selectedStateName,
        city: "", // ✅ reset city only when state changes
      }));
      fetchCities(selectedStateName);
    }}
  >
    <MenuItem value="">Select State</MenuItem>
    {states.map((state, idx) => (
      <MenuItem key={idx} value={state}>
        {state}
      </MenuItem>
    ))}
  </Select>
  {errors.state && <FormHelperText error>{errors.state}</FormHelperText>}
</FormControl>


    </Grid> */}

        {/* <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth disabled={loading}>
            <InputLabel>Zone</InputLabel>
            <Select
              name="zone"
              value={formData.zone}
              label="Zone"
              onChange={handleChange}
            >
              <MenuItem value="">Select Zone</MenuItem>

              {zonelist.map((zone) => (
                <MenuItem key={zone.id} value={zone.name}>
                  {zone.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}


        {/* <Grid item xs={12} sm={6} md={3}>
     <FormControl fullWidth disabled={loading || !formData.state} error={!!errors.city}>
  <InputLabel>City</InputLabel>
  <Select
    name="city"
    value={formData.city}
    label="City"
    onChange={handleChange}
  >
    <MenuItem value="">Select City</MenuItem>
    {loadingCities ? (
      <MenuItem disabled>Loading...</MenuItem>
    ) : (
      cities.map((city, idx) => (
        <MenuItem key={idx} value={city.cityName || city}>
          {city.cityName || city}
        </MenuItem>
      ))
    )}
  </Select>
  {errors.city && <FormHelperText error>{errors.city}</FormHelperText>}
</FormControl>

    </Grid> */}

        {/* <Grid item xs={12} sm={6} md={3}>
      <FormControl fullWidth disabled={loading} >
       
        <InputLabel>Area</InputLabel>
        <Select
          name="area"
          value={formData.area}
          label="Area"
          onChange={handleChange}
        >
          <MenuItem value="">Select Area</MenuItem>
          <MenuItem value="Area 1">Area 1</MenuItem>
          <MenuItem value="Area 2">Area 2</MenuItem>
        </Select>
   
      </FormControl>
    </Grid> */}




        {/* <Grid item xs={12} sm={6} md={3}>
      <TextField
        fullWidth
        label="Post Code"
        name="postCode"
        value={formData.postCode}
        onChange={handleChange}
        disabled={loading}
        error={!!errors.postCode}
        helperText={errors.postCode}
      />
    </Grid> */}

        <Grid item xs={6} >
          <Autocomplete
            options={areaList}
            loading={!areaList.length}

            value={
              areaList.find(
                (a) => String(a.id) === String(formData.areaId)
              ) ?? null
            }

            getOptionLabel={(option) =>
              `${option.name} / ${option.districtName} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
            }

            isOptionEqualToValue={(option, value) =>
              String(option.id) === String(value.id)
            }

            onChange={(_, newValue) => {
              console.log(newValue)
              setFormData((prev) => ({
                ...prev,
                areaId: newValue ? newValue.id : '',
                areaName: newValue ? newValue.cityName : ''
              }));
            }}

            inputValue={selectedAreaId}
            onInputChange={(_, newInputValue) => {
              setSelectedAreaId(newInputValue)
            }}

            renderInput={(params) => (
              <TextField
                {...params}
                label="Area (City)"
                fullWidth
                error={!!errors.areaId}
                helperText={errors.areaId}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {!areaList.length && <CircularProgress size={18} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                  autoComplete: "off"
                }}
              />
            )}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>Contact & Tax Information</Typography>
      <Grid container spacing={3}>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Phone No."
            name="phoneNo"
            value={formData.phoneNo}
            onChange={handleChange}
            disabled={loading}
            error={!!errors.phoneNo}
            helperText={errors.phoneNo}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Mobile No."
            name="mobileNo"
            value={formData.mobileNo}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.mobileNo}
          // helperText={errors.mobileNo}
          />
        </Grid>



        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Email"
            name="email"

            value={formData.email}
            onChange={handleChange}
            disabled={loading}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Service Tax No."
            name="serviceTaxNo"
            value={formData.serviceTaxNo}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.serviceTaxNo}
          // helperText={errors.serviceTaxNo}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Entertainment Tax No."
            name="entertainmentTaxNo"
            value={formData.entertainmentTaxNo}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.entertainmentTaxNo}
          // helperText={errors.entertainmentTaxNo}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="GST No."
            name="gstNo"
            value={formData.gstNo}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.gstNo}
          // helperText={errors.gstNo}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="PAN No."
            name="panNo"
            value={formData.panNo}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.panNo}
          // helperText={errors.panNo}
          />
        </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
             <TextField
  select
  fullWidth
  size="small"
  label="Billing Tax Type"
  name="billingTaxId"
  value={formData.billingTaxId}
  onChange={handleChange}
 
>
  {billingTaxTypes.map((item) => (
    <MenuItem key={item.id} value={item.id}>
      {item.name}
    </MenuItem>
  ))}
</TextField>
          </Grid>
        

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Aadhar No."
            name="aadharNo"
            value={formData.aadharNo}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.aadharNo}
          // helperText={errors.aadharNo}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>Financial Information</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Credit Limit (in Amount)"
            name="creditLimit"
            type="number"
            value={formData.creditLimit}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.creditLimit}
          // helperText={errors.creditLimit}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Online Recharge Minimum Amount"
            name="onlineRechargeMinAmount"
            type="number"
            value={formData.onlineRechargeMinAmount}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.onlineRechargeMinAmount}
          // helperText={errors.onlineRechargeMinAmount}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Business Name"
            name="businessName"
            value={formData.businessName}
            onChange={handleChange}
            disabled={loading}
          // error={!!errors.businessName}
          // helperText={errors.businessName}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
          fullWidth
          type='number'
          name="subscriptionExtendedDays"
          label="Subscription Extended Days"
          value={formData.subscriptionExtendedDays}
          onChange={handleChange}
          disabled={loading}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
  <Button variant="contained" component="label">
    Upload Company Logo
    <input
      type="file"
      hidden
      accept="image/*"
      onChange={handleImageChange}
    />
  </Button>

  {logoPreview && (
    <Box
      component="img"
      src={logoPreview}
      alt="Logo Preview"
      sx={{
        mt: 2,
        width: 120,
        height: 120,
        objectFit: "cover",
        borderRadius: 2,
        border: "1px solid #ccc"
      }}
    />
  )}
</Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>Franchisee Settings</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth disabled={loading} error={!!errors.priceListId}>
            <InputLabel>Franchisee PriceList*</InputLabel>
            <Select
              name="priceListId"
              value={formData.priceListId}
              label="Franchisee PriceList*"
              onChange={handleChange}
            // disabled={priceLists.length === 0}
            >
              <MenuItem value="">Select Price List</MenuItem>
              {priceLists.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.areaName} - {p.locationName}
                </MenuItem>
              ))}
            </Select>
            {errors.priceListId && <FormHelperText error>{errors.priceListId}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                name="disablePostPaidCustomerCreation"
                checked={formData.disablePostPaidCustomerCreation}
                onChange={handleSwitchChange}
                color="primary"
                disabled={loading}
              />
            }
            label="Disable PostPaid Customer Creation"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                name="isApplyFranchiseeInfoInBill"
                checked={formData.isApplyFranchiseeInfoInBill}
                onChange={handleSwitchChange}
                color="primary"
                disabled={loading}
              />
            }
            label="Apply Franchisee Info In Bill"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                name="isManageUserWallet"
                checked={formData.isManageUserWallet}
                onChange={handleSwitchChange}
                color="primary"
                disabled={loading}
              />
            }
            label="Manage User Wallet"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
  <FormControlLabel
    control={
      <Switch
        name="isManageLCOWallet"
        checked={formData.isManageLCOWallet}
        onChange={handleSwitchChange}
        color="primary"
        disabled={loading}
      />
    }
    label="Manage LCO Wallet"
  />
</Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                name="disableSubTypeDay"
                checked={formData.disableSubTypeDay}
                onChange={handleSwitchChange}
                color="primary"
                disabled={loading}
              />
            }
            label="Disable SubType Day"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Switch
                name="disableSubTypeOption"
                checked={formData.disableSubTypeOption}
                onChange={handleSwitchChange}
                color="primary"
                disabled={loading}
              />
            }
            label="Disable SubType Option"
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />
      {/* <Typography variant="h6" gutterBottom>Logo</Typography>
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Typography variant="body2" color="text.secondary">
        Best Size (250 * 250)
      </Typography>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={loading}
      />
      {errors.logo && <Typography variant="caption" color="error">{errors.logo}</Typography>}
      <Typography variant="caption" color="text.secondary">
        NOTE: Attached image thumbnail is supported in Latest Firefox, Chrome, Opera, Safari and Internet Explorer 10 only
      </Typography>
    </Grid>
  </Grid> */}

      <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 3 }}>
        <Grid item>
          <Button
            variant="outlined"
            onClick={() => navigate('/franchise')}
            disabled={loading}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
            onClick={handleSubmit}
          >
            {loading ? 'Creating...' : 'Add Franchisee'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddFranchisee;